<template>
  <div>
    <a-modal
      title="营养周/月报"
      :visible="shownutritionreport"
      @ok="shownutritionreport = false"
      @cancel="shownutritionreport = false"
      class="custom-model"
      width="400px"
      :footer="null"
    >
      <div class="nutritionreportlink-model">
        <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="类型">
            <a-select
              placeholder="请选择类型"
              size="large"
              v-model="reportDateType"
              @change="changeReportType"
            >
              <a-select-option value="week"> 周报 </a-select-option>
              <a-select-option value="month"> 月报 </a-select-option>
            </a-select>
          </a-form-item>
          <div v-if="reportDateType">
            <a-form-item label="周/月">
              <a-date-picker
                size="large"
                :defaultPickerValue="defaultWeek"
                style="width: 100%"
                placeholder="请选择周"
                :disabledDate="disabledDate"
                v-model="weekDate"
                :format="customFormat"
                v-if="reportDateType === 'week'"
              />
              <a-month-picker
                size="large"
                style="width: 100%"
                :disabledDate="disabledMonth"
                placeholder="请选择月份"
                v-model="monthDate"
                v-else
              />
            </a-form-item>
            <div class="report" v-if="weekDate || monthDate">
              <a-row>
                <a-col :span="18" :offset="4">
                  <div class="link">
                    <div
                      class="cell"
                      v-for="item in reportTypeList"
                      :key="item.type"
                    >
                      <a @click="showNutritionReportCode(item)">{{
                        item.name
                      }}</a>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-form>
      </div>
    </a-modal>
    <a-modal
      :visible="showQcode"
      @cancel="showQcode = false"
      width="460px"
      :footer="null"
      class="reportDatailModal"
    >
      <!-- <div class="reportlink-modal" style="text-align: center;">
        <qrcode-vue :value="reportUrl" :size="220" level="L"></qrcode-vue>
        微信扫一扫
      </div> -->
       <iframe :src="reportUrl" frameborder="0" width="460px" height="800px" seamless></iframe>
    </a-modal>
  </div>
</template>

<script>
// import QrcodeVue from 'qrcode.vue'
import moment from 'moment'
export default {
  inject: ['eventBus'],
  // components: {
  //   QrcodeVue
  // },
  data () {
    return {
      shownutritionreport: false,
      reportTypeList: [
        { type: 'meal', name: '用餐报告' },
        { type: 'intake', name: '营养摄入报告' },
        { type: 'structure', name: '膳食结构报告' },
        { type: 'element', name: '矿物质及维生素摄入报告' }
      ],
      reportDateType: 'month',
      defaultWeek: moment().subtract(7, 'days'),
      weekDate: '',
      monthDate: '',
      showQcode: false,
      reportUrl: '',
      date: '',
      typeName: ''
    }
  },
  methods: {
    changeReportType () {
      this.weekDate = ''
      this.monthDate = ''
    },
    showNutritionReportCode ({ type, name }) {
      this.typeName = name
      let dateStart = ''
      let dateEnd = ''
      let date = ''
      if (this.reportDateType === 'week') {
        const month = moment(this.weekDate).month()
        dateStart =
          moment(this.weekDate).startOf('week').month() === month
            ? moment(this.weekDate).startOf('week').format('YYYY-MM-DD')
            : moment(this.weekDate).startOf('month').format('YYYY-MM-DD')
        dateEnd =
          moment(this.weekDate).endOf('week').month() === month
            ? moment(this.weekDate).endOf('week').format('YYYY-MM-DD')
            : moment(this.weekDate).endOf('month').format('YYYY-MM-DD')
        date = this.date
      } else {
        dateStart = moment(this.monthDate)
          .startOf('month')
          .format('YYYY-MM-DD')
        dateEnd = moment(this.monthDate).endOf('month').format('YYYY-MM-DD')
        date = moment(this.monthDate).endOf('month').format('YYYY年M月')
      }
      this.reportUrl = `${this.getDomain(type)}?customer_id=${this.customer_id}&date=${date}&date_start=${dateStart}&date_end=${dateEnd}&date_type=${this.reportDateType}&demo_type=${this.appScene}`
      this.showQcode = true
    },
    getDomain (type) {
      if (location.host === 'k12.jianshihui.net') {
        return `https://p.jianshihui.net/nutrition/${this.company_id}/report/${type}`
      }
      if (location.host === 'uat-k12.aituancan.cn') {
        return `https://uat-c.aituancan.cn/nutrition/${this.company_id}/report/${type}`
      }
      return `https://canteen-sb.botwave.net/nutrition/${this.company_id}/report/${type}`
    },
    openReportModel (info) {
      this.company_id = info.company_id
      this.customer_id = info.customer_id
      this.shownutritionreport = true
    },
    customFormat (value) {
      const d = value.date()
      const w = value.day()
      const week = Math.ceil((d + (w === 0 ? 0 : 6 - w)) / 7)
      const month = moment(value).format('YYYY年M月')
      this.date = `${month}第${week}周`
      return this.date
    },
    disabledDate (current) {
      return current && (current >= moment().startOf('week') || current < moment().subtract(6, 'months'))
    },
    disabledMonth (current) {
      return current && (current >= moment().startOf('month') || current < moment().subtract(6, 'months'))
    }
  },
  async created () {
    this.eventBus.$on('show-report-qrcode-modal', this.openReportModel)
  },
  beforeDestroy () {
    this.eventBus.$off('show-report-qrcode-modal', this.openReportModel)
  }
}
</script>

<style lang="less">
.reportDatailModal {
  .ant-modal-body {
    padding: 0 !important;
  }
}
</style>
